import React from "react";
import {
    Paper,
    MenuItem,
    ListItemText,
    Box,
    Typography,
} from "@mui/material";
import assignment from "../assets/images/assignment.svg";
import history from "../assets/images/history.svg";

const iconMap: { [key: string]: string } = {
    "Assign Someone": assignment,
    "Assign me": assignment,
    "History": history,
};

const Dropdown = ({
    onClose,
    options,
    onClick
}: {
    onClose?: () => void;
    options: any[];
    onClick: any
}) => {
    return (
        <Paper
            elevation={3}
            sx={{
                position: "absolute",
                zIndex: 10,
                mt: 1,
                width: 200,
                borderRadius: "12px",
                backgroundColor: "#ffffff",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                overflow: "hidden",
            }}
        >
            <Box>
                {options.map((label, index) => (
                    <MenuItem
                        key={label}
                        onClick={() => onClick(label)}
                        sx={{
                            py: 1.5,
                            px: 2,
                            display: "flex",
                            gap: 2,
                            alignItems: "center",
                            borderBottom:
                                index !== options.length - 1
                                    ? "1px solid #DFDDDD"
                                    : "none",
                            "&:hover": {
                                backgroundColor: "#f9f9f9",
                            },
                        }}
                    >
                        <img
                            src={iconMap[label] || assignment}
                            alt={label}
                            style={{ width: 22, height: 22 }}
                        />
                        <Typography
                            fontSize={14}
                            fontWeight={500}
                            color="#000000"
                            sx={{ whiteSpace: "nowrap" }}
                            onClick={onClick}
                        >
                            {label}
                        </Typography>
                    </MenuItem>
                ))}
            </Box>
        </Paper>
    );
};

export default Dropdown;
